import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/useAuthStore";
import { Spinner } from "@/components/common/Spinner";

type Props = { children: ReactNode };

/**
 * Allows only super-admin users. Anonymous or non-super-admin users are
 * redirected to `/admin/login` on the same admin host. (Batch 27c — was
 * previously a cross-domain redirect to `${VITE_APP_BASE_URL}/login`,
 * which dead-ended because the tenant login form requires a tenant slug
 * and super admins have tenant_id=NULL.)
 */
export function RequireSuperAdmin({ children }: Props): JSX.Element {
  const status = useAuthStore((state) => state.status);
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin);

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (status === "anonymous" || !isSuperAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
